import { rest } from 'msw';

import { usersMock } from '../usersSelection.mock';
import { API_REST_URL } from 'config/variables';

const lmsUrl = API_REST_URL;

const getUsersByFilters = rest.post(
  `${lmsUrl}/algo/users/:clientId`,
  (req, res, ctx) => {
    return res(
      //   ctx.delay(1000),
      ctx.json({
        data: {
          users: usersMock,
          count: usersMock.length,
        },
        status: 'success',
      }),
    );
  },
);

export const usersSelectionHandlers = [getUsersByFilters];
